export default "__VITE_ASSET__oypaivAk__"